/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_GeneralInputs */

const en_admin_resource_form_general = /** @type {(inputs: Admin_Resource_Form_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General`)
};

const de_admin_resource_form_general = /** @type {(inputs: Admin_Resource_Form_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allgemein`)
};

const es_admin_resource_form_general = /** @type {(inputs: Admin_Resource_Form_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General`)
};

const fr_admin_resource_form_general = /** @type {(inputs: Admin_Resource_Form_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Général`)
};

/** @type {(inputs: Admin_Resource_Form_GeneralInputs) => LocalizedString} */
const it_admin_resource_form_general = en_admin_resource_form_general;

/** @type {(inputs: Admin_Resource_Form_GeneralInputs) => LocalizedString} */
const pt_br2_admin_resource_form_general = en_admin_resource_form_general;

/** @type {(inputs: Admin_Resource_Form_GeneralInputs) => LocalizedString} */
const pl_admin_resource_form_general = en_admin_resource_form_general;

/** @type {(inputs: Admin_Resource_Form_GeneralInputs) => LocalizedString} */
const hu_admin_resource_form_general = en_admin_resource_form_general;

/** @type {(inputs: Admin_Resource_Form_GeneralInputs) => LocalizedString} */
const ro_admin_resource_form_general = en_admin_resource_form_general;

/**
* | output |
* | --- |
* | "General" |
*
* @param {Admin_Resource_Form_GeneralInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_general = /** @type {((inputs?: Admin_Resource_Form_GeneralInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_GeneralInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_general(inputs)
	if (locale === "de") return de_admin_resource_form_general(inputs)
	if (locale === "es") return es_admin_resource_form_general(inputs)
	if (locale === "fr") return fr_admin_resource_form_general(inputs)
	if (locale === "it") return it_admin_resource_form_general(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_general(inputs)
	if (locale === "pl") return pl_admin_resource_form_general(inputs)
	if (locale === "hu") return hu_admin_resource_form_general(inputs)
	return ro_admin_resource_form_general(inputs)
});
export { admin_resource_form_general as "admin.resource_form.general" }